


// import React, { useState, useEffect } from 'react';
// import '../styles/OneOnOne.css';

// const OneOnOne = ({ userData, role }) => {
//   const isLeader = role === 'Management' || role === 'Manager';

//   // --- UI & LOADING STATE ---
//   // const [activeTab, setActiveTab] = useState('create');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isProcessing, setIsProcessing] = useState(false);

//   // --- MANAGER STATE ---
//   const [employeeList, setEmployeeList] = useState([]);
//   const [selectedEmp, setSelectedEmp] = useState(null);
//   const [date, setDate] = useState('');
//   const [discussion, setDiscussion] = useState('');
//   const [shareWithEmployee, setShareWithEmployee] = useState(false);
//   const [actions, setActions] = useState([{ task: '', dueDate: '', done: false }]);
//   const [managerHistory, setManagerHistory] = useState([]);

//   // --- EMPLOYEE STATE ---
//   const [myMeetings, setMyMeetings] = useState([]);

//   // --- INITIAL DATA LOAD ---
//   useEffect(() => {
//     if (isLeader) {
//      fetch("/gt-api/get_employees.php", {
//   credentials: "include"
// })
//         .then(res => res.json())
//         .then(data => setEmployeeList(data.employees || []));

//       fetch(`/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`, {
//   credentials: "include"
// })
//         .then(res => res.json())
//         .then(data => setManagerHistory(data.meetings || []));
//     } else {
//       fetch(`/gt-api/get_my_meetings.php?emp_id=${userData.id}`, {
//   credentials: "include"
// })
//         .then(res => res.json())
//         // .then(data => setMyMeetings(data.meetings || []));
//         .then(data => {
//           console.log("EMP DATA:", data.meetings);  // 👈 ADD HERE
//           setMyMeetings(data.meetings || []);
//         });

//     }
//   }, [isLeader, userData.id]);

//   const addActionRow = () => setActions([...actions, { task: '', dueDate: '', done: false }]);

//   // --- ACTION: SAVE COMPLETED MEETING (MANAGER) ---
//   const handleFinalSave = async () => {
//     if (!selectedEmp || !date) {
//       alert("Please select both a date and an employee.");
//       return;
//     }
//     setIsProcessing(true);
//     const payload = {
//       manager_id: userData.id,
//       employee_id: selectedEmp.id,
//       date: date,
//       discussion: discussion,
//       actions: JSON.stringify(actions),
//       show_summary: shareWithEmployee ? 1 : 0
//     };

//     try {
//       const response = await fetch('/gt-api/save_one_on_one.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert("SUCCESS: Meeting logged!");
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error("Save Error:", error);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // --- ACTION: REPORT MISSED MEETING ---
//   const handleMissedMeeting = async () => {
//     if (!selectedEmp || !date) {
//       alert("Select employee and date to report a missed meeting.");
//       return;
//     }
//     const confirmMissed = window.confirm(`PROTOCOL ALERT: Report ${selectedEmp.FirstName} as ABSENT?`);
//     if (!confirmMissed) return;

//     setIsProcessing(true);
//     const payload = {
//       manager_id: userData.id,
//       manager_name: `${userData.FirstName} ${userData.LastName}`,
//       employee_id: selectedEmp.id,
//       employee_name: `${selectedEmp.FirstName} ${selectedEmp.LastName}`,
//       date: date
//     };

//     try {
//       const response = await fetch('/gt-api/report_missed_meeting.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert("ALERT SENT: HR and Employee have been notified.");
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // --- ACTION: EMPLOYEE TASK TOGGLE (THE SYNC FIX) ---
//   // --- ACTION: EMPLOYEE TASK TOGGLE ---
//   const handleToggleTask = async (meetingId, taskIndex) => {
//     // If meetingId is undefined or 0, the update will fail
//     if (!meetingId) {
//       alert("Error: This meeting hasn't been saved to the database yet.");
//       return;
//     }

//     let updatedItemsString = "";

//     const updatedMeetings = myMeetings.map(meet => {
//       if (meet.id === meetingId) {
//         let tasks = JSON.parse(meet.action_items || "[]");

//         // ✅ prevent unchecking once done
//         if (!tasks[taskIndex].done) {
//           tasks[taskIndex].done = true;
//         }

//         updatedItemsString = JSON.stringify(tasks);
//         return { ...meet, action_items: updatedItemsString };
//       }
//       return meet;
//     });

//     setMyMeetings(updatedMeetings);

//     try {
//       const response = await fetch('/gt-api/update_1to1_tasks.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: meetingId,
//           action_items: updatedItemsString
//         })
//       });

//       const result = await response.json();

//       if (result.success) {
//         // 🔥 NEW: refresh manager-side data (no reload needed)
//         if (isLeader && selectedEmp) {
//           fetch(
//   `/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`,
//   {
//     credentials: "include"
//   }
// )
//   .then(res => res.json())
//   .then(data => {
//     const filtered = (data.meetings || []).filter(
//       m => m.employee_name === `${selectedEmp.FirstName} ${selectedEmp.LastName}`
//     );
//     setEmployeeHistory(filtered);
//   });
//         }
//       } else {
//         console.error("Database Update Failed:", result.message);
//       }

//     } catch (error) {
//       console.error("Network Error:", error);
//       alert("Connection failed. Ensure the record exists in the database.");
//     }
//   };


//   const filteredHistory = [...managerHistory]
//     .filter(meet => meet.employee_name?.toLowerCase().includes(searchTerm.toLowerCase()))
//     .sort((a, b) => b.id - a.id);


//   const uniqueEmployees = [...new Set(filteredHistory.map(m => m.employee_name))];


//   const groupedByEmployee = filteredHistory.reduce((acc, meet) => {
//     const name = meet.employee_name || "Unknown";

//     if (!acc[name]) {
//       acc[name] = [];
//     }

//     acc[name].push(meet);
//     return acc;
//   }, {});

//   const [selectedEmployeeHistory, setSelectedEmployeeHistory] = useState(null);
//   const [openMeetingId, setOpenMeetingId] = useState(null);

//   const [editingMeetingId, setEditingMeetingId] = useState(null);
//   const [editDiscussion, setEditDiscussion] = useState('');
//   const [editTasks, setEditTasks] = useState([]);
//   const handleUpdateMeeting = async (id) => {
//     try {
//       const response = await fetch('/gt-api/update_one_on_one_meeting.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id,
//           discussion: editDiscussion,
//           actions: JSON.stringify(editTasks)
//         })
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert("Updated successfully");

//         setEditingMeetingId(null);

//         // 🔥 refresh UI
//         setEmployeeHistory(prev =>
//           prev.map(m =>
//             m.id === id
//               ? { ...m, discussion: editDiscussion, action_items: JSON.stringify(editTasks) }
//               : m
//           )
//         );
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const [empSearch, setEmpSearch] = useState('');
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [employeeHistory, setEmployeeHistory] = useState([]);

//   useEffect(() => {
//     if (!selectedEmp) return;

//     fetch(
//   `/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`,
//   {
//     credentials: "include"
//   }
// )
//       .then(res => res.json())
//       .then(data => {

//         const allMeetings = data.meetings || [];

//         // ✅ CORRECT PLACE
//         console.log("ONE MEETING:", allMeetings[0]);

//         const filtered = allMeetings.filter(
//           m => m.employee_name === `${selectedEmp.FirstName} ${selectedEmp.LastName}`
//         );

//         console.log("FILTERED:", filtered);

//         setEmployeeHistory(filtered);
//       });

//   }, [selectedEmp]);


//   return (
//     <div className="one-on-one-container module-glass-card animate-fade">
//       {isLeader ? (
//         /* --- MANAGEMENT / LEADER VIEW --- */
//         <div className="leader-view">

//           <hr className="cyber-divider" />

//           {/* ✅ KEEP YOUR ORIGINAL CREATE UI */}
//           <div className="create-section">
//             <div className="meet-grid">
//               {/* <div className="input-field">
//                 <label>Select Date</label>
//                 <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="cyber-input" />
//               </div> */}

//               <div className="input-field date-field">
//                 <label>Select Date</label>
//                 <input
//                   type="date"
//                   value={date}
//                   onChange={(e) => setDate(e.target.value)}
//                   className="cyber-input"
//                 />
//                 <span className="calendar-icons">📅</span>
//               </div>


//               <div className="input-field">
//                 <label>Employee Name</label>
//                 <div className="employee-search-wrapper">
//                   <input
//                     type="text"
//                     placeholder="Search Employee..."
//                     className="cyber-input"
//                     value={empSearch}
//                     onChange={(e) => {
//                       setEmpSearch(e.target.value);
//                       setShowDropdown(true);
//                     }}
//                     onFocus={() => setShowDropdown(true)}
//                   />

//                   {showDropdown && (
//                     <div className="employee-dropdown">
//                       {employeeList
//                         .filter(emp =>
//                           `${emp.FirstName} ${emp.LastName}`
//                             .toLowerCase()
//                             .includes(empSearch.toLowerCase())
//                         )
//                         .map(emp => (
//                           <div
//                             key={emp.id}
//                             className="dropdown-item"
//                             onClick={() => {
//                               setSelectedEmp(emp);
//                               setEmpSearch(`${emp.FirstName} ${emp.LastName}`);
//                               setShowDropdown(false);
//                             }}
//                           >
//                             {emp.FirstName} {emp.LastName}
//                           </div>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="input-field">
//                 <label>Department</label>
//                 <input type="text" readOnly value={selectedEmp?.Department || ''} className="cyber-input readonly" />
//               </div>
//             </div>

//             <div className="discussion-area">
//               <div className="discussion-header-row">
//                 <label>Discussion Summary</label>
//                 <div className="share-toggle-container">
//                   <input type="checkbox" id="share-check" checked={shareWithEmployee} onChange={(e) => setShareWithEmployee(e.target.checked)} />
//                   <label htmlFor="share-check" className="share-label">Share with Employee?</label>
//                 </div>
//               </div>
//               <textarea value={discussion} onChange={(e) => setDiscussion(e.target.value)} className="cyber-textarea" placeholder="Summarize key points..." />
//             </div>

//             <div className="actions-section">
//               <h4>ACTION REQUIRED</h4>

//               <div className="action-row-headers" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                 <label className="header-date" style={{ marginRight: '65px' }}>Due Date</label>
//               </div>

//               {actions.map((item, index) => (
//                 <div key={index} className="action-row-enhanced">
//                   <input
//                     type="text"
//                     placeholder="Task description"
//                     className="task-input"
//                     onChange={(e) => {
//                       const newActions = [...actions];
//                       newActions[index].task = e.target.value;
//                       setActions(newActions);
//                     }}
//                   />
//                   <input
//                     type="date"
//                     className="date-picker-mini"
//                     onChange={(e) => {
//                       const newActions = [...actions];
//                       newActions[index].dueDate = e.target.value;
//                       setActions(newActions);
//                     }}
//                   />
//                 </div>
//               ))}

//               <button onClick={addActionRow} className="btn-add-row">+ Add Item</button>
//             </div>

//             <div className="button-group-main">
//               <button onClick={handleFinalSave} className="btn-save-meet" disabled={isProcessing}>
//                 {isProcessing ? "SAVING..." : "SUBMIT REPORT"}
//               </button>
//               <button onClick={handleMissedMeeting} className="btn-missed-meet" disabled={isProcessing}>
//                 MARK AS MISSED
//               </button>
//             </div>
//           </div>

//           {/* ✅ ADD THIS NEW HISTORY SECTION */}
//           <div className="employee-history-inline">

//             {!selectedEmp ? (
//               <div className="empty-history-dark">
//                 <div className="empty-icon">📊</div>
//                 <h4>No Employee Selected</h4>
//                 <p>Select an employee to view their meeting history</p>
//               </div>
//             ) : (
//               <>
//                 <h3 style={{ marginTop: "20px" }}>
//                   {selectedEmp.FirstName}'s Previous Meetings
//                 </h3>

//                 {employeeHistory.length === 0 && (
//                   <p style={{ opacity: 0.6 }}>No history found</p>
//                 )}

//                 {
//                   employeeHistory.map(meet => {
//                     // const isMissed = meet.status === "MISSED";
//                     const isMissed =
//                       meet.status === "MISSED" ||
//                       meet.discussion?.includes("MISSED_MEETING_REPORT");
//                     const tasks = JSON.parse(meet.action_items || "[]");

//                     return (
//                       <div key={meet.id} className={`history-card ${isMissed ? 'missed' : ''}`}>

//                         {/* HEADER */}
//                         <div className="history-header">
//                           <div className="history-date">
//                             📅 {meet.meet_date}
//                           </div>

//                           {/* EDIT BUTTON */}
//                           {!isMissed && (
//                             <button
//                               className="edit-btn"
//                               onClick={() => {
//                                 setEditingMeetingId(meet.id);
//                                 setEditDiscussion(meet.discussion);
//                                 setEditTasks(tasks);
//                               }}
//                             >
//                               ✏️ Edit
//                             </button>
//                           )}
//                         </div>

//                         {/* MISSED */}
//                         {isMissed ? (
//                           <div className="missed-box">
//                             ❌ Missed Meeting
//                           </div>
//                         ) : (
//                           <>
//                             {/* DISCUSSION */}
//                             <div className="history-discussion">
//                               {meet.discussion?.split('\n').map((line, i) => (
//                                 <p key={i}>{line}</p>
//                               ))}
//                             </div>

//                             {/* ACTION ITEMS */}
//                             {tasks.length > 0 && (
//                               <div className="history-tasks">
//                                 <h5>Action Items</h5>

//                                 {tasks.map((task, i) => (
//                                   <div key={i} className={`task-item ${task.done ? 'completed' : ''}`}>

//                                     <div className="task-text">
//                                       {task.done ? "✅ " : ""}{task.task}
//                                     </div>

//                                     <div className="task-date">📅 {task.dueDate}</div>

//                                   </div>
//                                 ))}
//                               </div>
//                             )}
//                           </>
//                         )}

//                         {/* EDIT MODE */}
//                         {editingMeetingId === meet.id && (
//                           <div className="edit-container">

//                             <h4 className="edit-title">✏️ Edit Meeting</h4>

//                             {/* DISCUSSION */}
//                             <div className="edit-group">
//                               <label>Discussion</label>
//                               <textarea
//                                 className="edit-textarea"
//                                 value={editDiscussion}
//                                 onChange={(e) => setEditDiscussion(e.target.value)}
//                               />
//                             </div>

//                             {/* TASKS */}
//                             <div className="edit-group">
//                               <label>Action Items</label>

//                               {editTasks.map((t, i) => (
//                                 <div key={i} className="edit-task-row">
//                                   <input
//                                     className="edit-task-input"
//                                     value={t.task}
//                                     placeholder="Task..."
//                                     onChange={(e) => {
//                                       const updated = [...editTasks];
//                                       updated[i].task = e.target.value;
//                                       setEditTasks(updated);
//                                     }}
//                                   />

//                                   <input
//                                     type="date"
//                                     className="edit-date-input"
//                                     value={t.dueDate}
//                                     onChange={(e) => {
//                                       const updated = [...editTasks];
//                                       updated[i].dueDate = e.target.value;
//                                       setEditTasks(updated);
//                                     }}
//                                   />
//                                 </div>
//                               ))}

//                               <button
//                                 className="add-task-btn"
//                                 onClick={() =>
//                                   setEditTasks([...editTasks, { task: "", dueDate: "" }])
//                                 }
//                               >
//                                 + Add Task
//                               </button>
//                             </div>

//                             {/* ACTION BUTTONS */}
//                             <div className="edit-actions">
//                               <button
//                                 className="cancel-btn"
//                                 onClick={() => setEditingMeetingId(null)}
//                               >
//                                 Cancel
//                               </button>

//                               <button
//                                 className="save-btn"
//                                 onClick={() => handleUpdateMeeting(meet.id)}
//                               >
//                                 Save Changes
//                               </button>
//                             </div>

//                           </div>
//                         )}

//                       </div>
//                     );
//                   })
//                 }


//               </>
//             )}

//           </div>

//         </div>
//       ) : (
//         /* --- EMPLOYEE VIEW --- */
//         <div className="employee-view">
//           {/* <h3 className="dashboard-headline">🚀 ACTION REQUIRED TO EMPLOYEE DASHBOARD</h3> */}

//           {myMeetings.length > 0 ? myMeetings.map(meet => {

//             const tasks = JSON.parse(meet.action_items || "[]")
//               .filter(t => t.task && t.task.trim() !== "");

//             return (
//               <div key={meet.id} className="meet-log-card">

//                 <div className="meet-header">
//                   <span>📅 {meet.meet_date}</span>
//                   <span>👤 Manager: {meet.manager_name}</span>
//                 </div>

//                 <div className="employee-content-box">

//                   {/* ✅ DETECT MISSED */}
//                   {(
//                     meet.status === "MISSED" ||
//                     meet.discussion?.includes("MISSED_MEETING_REPORT")
//                   ) ? (
//                     <div className="missed-box">
//                       ❌ You missed this meeting
//                     </div>
//                   ) : (
//                     <>
//                       {meet.show_summary === 1 ? (
//                         <div className="emp-disc">
//                           {meet.discussion?.split('\n').map((line, idx) => (
//                             <div key={idx} className="discussion-line">
//                               {line}
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <p className="restricted">Summary private.</p>
//                       )}

//                       {/* ✅ SHOW ONLY IF TASKS EXIST */}
//                       {tasks.length > 0 && (
//                         <div className="action-checklist">
//                           <h5>Your Action Items:</h5>

//                           {tasks.map((item, i) => (
//                             <div key={i} className={`task-card ${item.done ? 'completed' : ''}`}>
//                               <div className="task-left">
//                                 <div className="task-title">{item.task}</div>
//                                 <div className="task-meta">📅 {item.dueDate}</div>
//                               </div>

//                               <input
//                                 type="checkbox"
//                                 className="task-checkbox"
//                                 checked={Boolean(item.done)}
//                                 disabled={item.done}
//                                 onChange={() => {
//                                   if (!item.done) {
//                                     handleToggleTask(meet.id, i);
//                                   }
//                                 }}
//                               />
//                             </div>
//                           ))}

//                         </div>
//                       )}
//                     </>
//                   )}

//                 </div>
//               </div>
//             );

//           }) : (
//             <p className="no-records">No 1-on-1 records found.</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default OneOnOne;




























// import React, { useState, useEffect } from 'react';
// import '../styles/OneOnOne.css';

// const OneOnOne = ({ userData, role }) => {
//   const isLeader = role === 'Management' || role === 'Manager';

//   // --- UI & LOADING STATE ---
//   // const [activeTab, setActiveTab] = useState('create');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [toast, setToast] = useState(null);

//   // --- MANAGER STATE ---
//   const [employeeList, setEmployeeList] = useState([]);
//   const [selectedEmp, setSelectedEmp] = useState(null);
//   const [date, setDate] = useState('');
//   const [discussion, setDiscussion] = useState('');
//   const [shareWithEmployee, setShareWithEmployee] = useState(false);
//   const [actions, setActions] = useState([{ task: '', dueDate: '', done: false }]);
//   const [managerHistory, setManagerHistory] = useState([]);

//   // --- EMPLOYEE STATE ---
//   const [myMeetings, setMyMeetings] = useState([]);

//   // --- INITIAL DATA LOAD ---
//   useEffect(() => {
//     if (isLeader) {
//       fetch("/gt-api/get_employees.php", {
//         credentials: "include"
//       })
//         .then(res => res.json())
//         .then(data => setEmployeeList(data.employees || []));

//       fetch(`/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`, {
//         credentials: "include"
//       })
//         .then(res => res.json())
//         .then(data => setManagerHistory(data.meetings || []));
//     } else {
//       fetch(`/gt-api/get_my_meetings.php?emp_id=${userData.id}`, {
//         credentials: "include"
//       })
//         .then(res => res.json())
//         // .then(data => setMyMeetings(data.meetings || []));
//         .then(data => {
//           console.log("EMP DATA:", data.meetings);  // 👈 ADD HERE
//           setMyMeetings(data.meetings || []);
//         });

//     }
//   }, [isLeader, userData.id]);

//   const addActionRow = () => setActions([...actions, { task: '', dueDate: '', done: false }]);

//   // --- ACTION: SAVE COMPLETED MEETING (MANAGER) ---
//   const handleFinalSave = async () => {
//     if (!selectedEmp || !date) {
//       setToast({ message: "Please select both a date and an employee.", type: "error" });
//       setTimeout(() => setToast(null), 4000);
//       return;
//     }
//     setIsProcessing(true);
//     const payload = {
//       manager_id: userData.id,
//       employee_id: selectedEmp.id,
//       date: date,
//       discussion: discussion,
//       actions: JSON.stringify(actions),
//       show_summary: shareWithEmployee ? 1 : 0
//     };

//     try {
//       const response = await fetch('/gt-api/save_one_on_one.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });

//       const rawText = await response.text();
//       let result = { success: false };
//       try {
//         result = JSON.parse(rawText);
//       } catch (e) {
//         if (response.ok) {
//           result = { success: true };
//         } else {
//           console.error("JSON parse error:", e, rawText);
//         }
//       }

//       if (result.success) {
//         setToast({ message: "Report submitted successfully!", type: "success" });
//         setTimeout(() => {
//           setToast(null);
//           window.location.reload();
//         }, 2000);
//       } else {
//         setToast({ message: "FAILED: " + (result.message || "Could not submit report."), type: "error" });
//         setTimeout(() => setToast(null), 4000);
//       }
//     } catch (error) {
//       console.error("Save Error:", error);
//       setToast({ message: "ERROR: Failed to connect to server. Report not submitted.", type: "error" });
//       setTimeout(() => setToast(null), 4000);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // --- ACTION: REPORT MISSED MEETING ---
//   const handleMissedMeeting = async () => {
//     if (!selectedEmp || !date) {
//       alert("Select employee and date to report a missed meeting.");
//       return;
//     }
//     const confirmMissed = window.confirm(`PROTOCOL ALERT: Report ${selectedEmp.FirstName} as ABSENT?`);
//     if (!confirmMissed) return;

//     setIsProcessing(true);
//     const payload = {
//       manager_id: userData.id,
//       manager_name: `${userData.FirstName} ${userData.LastName}`,
//       employee_id: selectedEmp.id,
//       employee_name: `${selectedEmp.FirstName} ${selectedEmp.LastName}`,
//       date: date
//     };

//     try {
//       const response = await fetch('/gt-api/report_missed_meeting.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload)
//       });
//       const result = await response.json();
//       if (result.success) {
//         alert("ALERT SENT: HR and Employee have been notified.");
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // --- ACTION: EMPLOYEE TASK TOGGLE (THE SYNC FIX) ---
//   // --- ACTION: EMPLOYEE TASK TOGGLE ---
//   const handleToggleTask = async (meetingId, taskIndex) => {
//     // If meetingId is undefined or 0, the update will fail
//     if (!meetingId) {
//       alert("Error: This meeting hasn't been saved to the database yet.");
//       return;
//     }

//     let updatedItemsString = "";

//     const updatedMeetings = myMeetings.map(meet => {
//       if (meet.id === meetingId) {
//         let tasks = JSON.parse(meet.action_items || "[]");

//         // ✅ prevent unchecking once done
//         if (!tasks[taskIndex].done) {
//           tasks[taskIndex].done = true;
//         }

//         updatedItemsString = JSON.stringify(tasks);
//         return { ...meet, action_items: updatedItemsString };
//       }
//       return meet;
//     });

//     setMyMeetings(updatedMeetings);

//     try {
//       const response = await fetch('/gt-api/update_1to1_tasks.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id: meetingId,
//           action_items: updatedItemsString
//         })
//       });

//       const result = await response.json();

//       if (result.success) {
//         // 🔥 NEW: refresh manager-side data (no reload needed)
//         if (isLeader && selectedEmp) {
//           fetch(
//             `/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`,
//             {
//               credentials: "include"
//             }
//           )
//             .then(res => res.json())
//             .then(data => {
//               const filtered = (data.meetings || []).filter(
//                 m => m.employee_name === `${selectedEmp.FirstName} ${selectedEmp.LastName}`
//               );
//               setEmployeeHistory(filtered);
//             });
//         }
//       } else {
//         console.error("Database Update Failed:", result.message);
//       }

//     } catch (error) {
//       console.error("Network Error:", error);
//       alert("Connection failed. Ensure the record exists in the database.");
//     }
//   };


//   const filteredHistory = [...managerHistory]
//     .filter(meet => meet.employee_name?.toLowerCase().includes(searchTerm.toLowerCase()))
//     .sort((a, b) => b.id - a.id);


//   const uniqueEmployees = [...new Set(filteredHistory.map(m => m.employee_name))];


//   const groupedByEmployee = filteredHistory.reduce((acc, meet) => {
//     const name = meet.employee_name || "Unknown";

//     if (!acc[name]) {
//       acc[name] = [];
//     }

//     acc[name].push(meet);
//     return acc;
//   }, {});

//   const [selectedEmployeeHistory, setSelectedEmployeeHistory] = useState(null);
//   const [openMeetingId, setOpenMeetingId] = useState(null);

//   const [editingMeetingId, setEditingMeetingId] = useState(null);
//   const [editDiscussion, setEditDiscussion] = useState('');
//   const [editTasks, setEditTasks] = useState([]);
//   const [editShare, setEditShare] = useState(false);
//   const handleUpdateMeeting = async (id) => {
//     try {
//       const response = await fetch('/gt-api/update_one_on_one_meeting.php', {
//         method: 'POST',
//         credentials: "include",
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           id,
//           discussion: editDiscussion,
//           actions: JSON.stringify(editTasks),
//           show_summary: editShare ? 1 : 0
//         })
//       });

//       const result = await response.json();

//       if (result.success) {
//         alert("Updated successfully");

//         setEditingMeetingId(null);

//         // 🔥 refresh UI
//         setEmployeeHistory(prev =>
//           prev.map(m =>
//             m.id === id
//               ? { ...m, discussion: editDiscussion, action_items: JSON.stringify(editTasks), show_summary: editShare ? 1 : 0 }
//               : m
//           )
//         );
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const [empSearch, setEmpSearch] = useState('');
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [employeeHistory, setEmployeeHistory] = useState([]);

//   useEffect(() => {
//     if (!selectedEmp) return;

//     fetch(
//       `/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`,
//       {
//         credentials: "include"
//       }
//     )
//       .then(res => res.json())
//       .then(data => {

//         const allMeetings = data.meetings || [];

//         // ✅ CORRECT PLACE
//         console.log("ONE MEETING:", allMeetings[0]);

//         const filtered = allMeetings.filter(
//           m => m.employee_name === `${selectedEmp.FirstName} ${selectedEmp.LastName}`
//         );

//         console.log("FILTERED:", filtered);

//         setEmployeeHistory(filtered);
//       });

//   }, [selectedEmp]);


//   return (
//     <div className="one-on-one-container module-glass-card animate-fade">
//       <style>{`
//         @keyframes toastSlideDown {
//           from { transform: translate(-50%, -20px); opacity: 0; }
//           to { transform: translate(-50%, 0); opacity: 1; }
//         }
//       `}</style>

//       {toast && (
//         <div style={{
//           position: 'fixed',
//           top: '20px',
//           left: '50%',
//           transform: 'translateX(-50%)',
//           backgroundColor: toast.type === 'success' ? '#10b981' : '#ef4444',
//           color: '#fff',
//           padding: '14px 28px',
//           borderRadius: '8px',
//           boxShadow: toast.type === 'success'
//             ? '0 10px 30px rgba(16, 185, 129, 0.3), 0 0 1px 1px rgba(255, 255, 255, 0.2)'
//             : '0 10px 30px rgba(239, 68, 68, 0.3), 0 0 1px 1px rgba(255, 255, 255, 0.2)',
//           backdropFilter: 'blur(8px)',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '12px',
//           zIndex: 99999,
//           fontFamily: "'Plus Jakarta Sans', sans-serif",
//           fontSize: '14px',
//           fontWeight: '600',
//           letterSpacing: '0.5px',
//           animation: 'toastSlideDown 0.3s ease-out forwards'
//         }}>
//           <span style={{ fontSize: '18px' }}>{toast.type === 'success' ? '✅' : '❌'}</span>
//           <span>{toast.message}</span>
//         </div>
//       )}

//       {isLeader ? (
//         /* --- MANAGEMENT / LEADER VIEW --- */
//         <div className="leader-view">

//           <hr className="cyber-divider" />

//           {/* ✅ KEEP YOUR ORIGINAL CREATE UI */}
//           <div className="create-section">
//             <div className="meet-grid">
//               {/* <div className="input-field">
//                 <label>Select Date</label>
//                 <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="cyber-input" />
//               </div> */}

//               <div className="input-field date-field">
//                 <label>Select Date</label>
//                 <input
//                   type="date"
//                   value={date}
//                   onChange={(e) => setDate(e.target.value)}
//                   className="cyber-input"
//                 />
//                 <span className="calendar-icons">📅</span>
//               </div>


//               <div className="input-field">
//                 <label>Employee Name</label>
//                 <div className="employee-search-wrapper">
//                   <input
//                     type="text"
//                     placeholder="Search Employee..."
//                     className="cyber-input"
//                     value={empSearch}
//                     onChange={(e) => {
//                       setEmpSearch(e.target.value);
//                       setShowDropdown(true);
//                     }}
//                     onFocus={() => setShowDropdown(true)}
//                   />

//                   {showDropdown && (
//                     <div className="employee-dropdown">
//                       {employeeList
//                         .filter(emp =>
//                           `${emp.FirstName} ${emp.LastName}`
//                             .toLowerCase()
//                             .includes(empSearch.toLowerCase())
//                         )
//                         .map(emp => (
//                           <div
//                             key={emp.id}
//                             className="dropdown-item"
//                             onClick={() => {
//                               setSelectedEmp(emp);
//                               setEmpSearch(`${emp.FirstName} ${emp.LastName}`);
//                               setShowDropdown(false);
//                             }}
//                           >
//                             {emp.FirstName} {emp.LastName}
//                           </div>
//                         ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="input-field">
//                 <label>Department</label>
//                 <input type="text" readOnly value={selectedEmp?.Department || ''} className="cyber-input readonly" />
//               </div>
//             </div>

//             <div className="discussion-area">
//               <div className="discussion-header-row">
//                 <label>Discussion Summary</label>
//                 <div className="share-toggle-container">
//                   <input type="checkbox" id="share-check" checked={shareWithEmployee} onChange={(e) => setShareWithEmployee(e.target.checked)} />
//                   <label htmlFor="share-check" className="share-label">Share with Employee?</label>
//                 </div>
//               </div>
//               <textarea value={discussion} onChange={(e) => setDiscussion(e.target.value)} className="cyber-textarea" placeholder="Summarize key points..." />
//             </div>

//             <div className="actions-section">
//               <h4>ACTION REQUIRED</h4>

//               <div className="action-row-headers" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                 <label className="header-date" style={{ marginRight: '65px' }}>Due Date</label>
//               </div>

//               {actions.map((item, index) => (
//                 <div key={index} className="action-row-enhanced">
//                   <input
//                     type="text"
//                     placeholder="Task description"
//                     className="task-input"
//                     onChange={(e) => {
//                       const newActions = [...actions];
//                       newActions[index].task = e.target.value;
//                       setActions(newActions);
//                     }}
//                   />
//                   <input
//                     type="date"
//                     className="date-picker-mini"
//                     onChange={(e) => {
//                       const newActions = [...actions];
//                       newActions[index].dueDate = e.target.value;
//                       setActions(newActions);
//                     }}
//                   />
//                 </div>
//               ))}

//               <button onClick={addActionRow} className="btn-add-row">+ Add Item</button>
//             </div>

//             <div className="button-group-main">
//               <button onClick={handleFinalSave} className="btn-save-meet" disabled={isProcessing}>
//                 {isProcessing ? "SAVING..." : "SUBMIT REPORT"}
//               </button>
//               <button onClick={handleMissedMeeting} className="btn-missed-meet" disabled={isProcessing}>
//                 MARK AS MISSED
//               </button>
//             </div>
//           </div>

//           {/* ✅ ADD THIS NEW HISTORY SECTION */}
//           <div className="employee-history-inline">

//             {!selectedEmp ? (
//               <div className="empty-history-dark">
//                 <div className="empty-icon">📊</div>
//                 <h4>No Employee Selected</h4>
//                 <p>Select an employee to view their meeting history</p>
//               </div>
//             ) : (
//               <>
//                 <h3 style={{ marginTop: "20px" }}>
//                   {selectedEmp.FirstName}'s Previous Meetings
//                 </h3>

//                 {employeeHistory.length === 0 && (
//                   <p style={{ opacity: 0.6 }}>No history found</p>
//                 )}

//                 {
//                   employeeHistory.map(meet => {
//                     // const isMissed = meet.status === "MISSED";
//                     const isMissed =
//                       meet.status === "MISSED" ||
//                       meet.discussion?.includes("MISSED_MEETING_REPORT");
//                     const tasks = JSON.parse(meet.action_items || "[]")
//                       .filter(t => t.task && t.task.trim() !== "");

//                     return (
//                       <div key={meet.id} className={`history-card ${isMissed ? 'missed' : ''}`}>

//                         {/* HEADER */}
//                         <div className="history-header">
//                           <div className="history-date">
//                             📅 {meet.meet_date}
//                           </div>

//                           {/* EDIT BUTTON */}
//                           {!isMissed && (
//                             <button
//                               className="edit-btn"
//                               onClick={() => {
//                                 setEditingMeetingId(meet.id);
//                                 setEditDiscussion(meet.discussion);
//                                 setEditTasks(tasks);
//                                 setEditShare(Number(meet.show_summary) === 1);
//                               }}
//                             >
//                               ✏️ Edit
//                             </button>
//                           )}
//                         </div>

//                         {/* MISSED */}
//                         {isMissed ? (
//                           <div className="missed-box">
//                             ❌ Missed Meeting
//                           </div>
//                         ) : (
//                           <>
//                             {/* DISCUSSION */}
//                             <div className="history-discussion">
//                               {meet.discussion?.split('\n').map((line, i) => (
//                                 <p key={i}>{line}</p>
//                               ))}
//                             </div>

//                             {/* ACTION ITEMS */}
//                             {tasks.length > 0 && (
//                               <div className="history-tasks">
//                                 <h5>Action Items</h5>

//                                 {tasks.map((task, i) => (
//                                   <div key={i} className={`task-item ${task.done ? 'completed' : ''}`}>

//                                     <div className="task-text">
//                                       {task.done ? "✅ " : ""}{task.task}
//                                     </div>

//                                     <div className="task-date">📅 {task.dueDate}</div>

//                                   </div>
//                                 ))}
//                               </div>
//                             )}
//                           </>
//                         )}

//                         {/* EDIT MODE */}
//                         {editingMeetingId === meet.id && (
//                           <div className="edit-container">

//                             <h4 className="edit-title">✏️ Edit Meeting</h4>

//                             {/* DISCUSSION */}
//                             <div className="edit-group">
//                               <label>Discussion</label>
//                               <textarea
//                                 className="edit-textarea"
//                                 value={editDiscussion}
//                                 onChange={(e) => setEditDiscussion(e.target.value)}
//                               />
//                             </div>

//                             {/* SHARE WITH EMPLOYEE TOGGLE */}
//                             <div className="edit-group" style={{ marginTop: '10px', marginBottom: '10px' }}>
//                               <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                 <input
//                                   type="checkbox"
//                                   id={`edit-share-${meet.id}`}
//                                   checked={editShare}
//                                   onChange={(e) => setEditShare(e.target.checked)}
//                                   style={{ cursor: 'pointer' }}
//                                 />
//                                 <label htmlFor={`edit-share-${meet.id}`} style={{ cursor: 'pointer', fontSize: '12px', userSelect: 'none', color: 'rgba(255, 255, 255, 0.7)' }}>
//                                   Share summary and action items with Employee?
//                                 </label>
//                               </div>
//                             </div>

//                             {/* TASKS */}
//                             <div className="edit-group">
//                               <label>Action Items</label>

//                               {editTasks.map((t, i) => (
//                                 <div key={i} className="edit-task-row">
//                                   <input
//                                     className="edit-task-input"
//                                     value={t.task}
//                                     placeholder="Task..."
//                                     onChange={(e) => {
//                                       const updated = [...editTasks];
//                                       updated[i].task = e.target.value;
//                                       setEditTasks(updated);
//                                     }}
//                                   />

//                                   <input
//                                     type="date"
//                                     className="edit-date-input"
//                                     value={t.dueDate}
//                                     onChange={(e) => {
//                                       const updated = [...editTasks];
//                                       updated[i].dueDate = e.target.value;
//                                       setEditTasks(updated);
//                                     }}
//                                   />
//                                 </div>
//                               ))}

//                               <button
//                                 className="add-task-btn"
//                                 onClick={() =>
//                                   setEditTasks([...editTasks, { task: "", dueDate: "" }])
//                                 }
//                               >
//                                 + Add Task
//                               </button>
//                             </div>

//                             {/* ACTION BUTTONS */}
//                             <div className="edit-actions">
//                               <button
//                                 className="cancel-btn"
//                                 onClick={() => setEditingMeetingId(null)}
//                               >
//                                 Cancel
//                               </button>

//                               <button
//                                 className="save-btn"
//                                 onClick={() => handleUpdateMeeting(meet.id)}
//                               >
//                                 Save Changes
//                               </button>
//                             </div>

//                           </div>
//                         )}

//                       </div>
//                     );
//                   })
//                 }


//               </>
//             )}

//           </div>

//         </div>
//       ) : (
//         /* --- EMPLOYEE VIEW --- */
//         <div className="employee-view">
//           {/* <h3 className="dashboard-headline">🚀 ACTION REQUIRED TO EMPLOYEE DASHBOARD</h3> */}

//           {myMeetings.length > 0 ? myMeetings.map(meet => {

//             const tasks = JSON.parse(meet.action_items || "[]")
//               .filter(t => t.task && t.task.trim() !== "");

//             return (
//               <div key={meet.id} className="meet-log-card">

//                 <div className="meet-header">
//                   <span>📅 {meet.meet_date}</span>
//                   <span>👤 Manager: {meet.manager_name}</span>
//                 </div>

//                 <div className="employee-content-box">

//                   {/* ✅ DETECT MISSED */}
//                   {(
//                     meet.status === "MISSED" ||
//                     meet.discussion?.includes("MISSED_MEETING_REPORT")
//                   ) ? (
//                     <div className="missed-box">
//                       ❌ You missed this meeting
//                     </div>
//                   ) : (
//                     <>
//                       {meet.show_summary === 1 ? (
//                         <div className="emp-disc">
//                           {meet.discussion?.split('\n').map((line, idx) => (
//                             <div key={idx} className="discussion-line">
//                               {line}
//                             </div>
//                           ))}
//                         </div>
//                       ) : (
//                         <p className="restricted">Summary private.</p>
//                       )}

//                       {/* ✅ SHOW ONLY IF TASKS EXIST */}
//                       {tasks.length > 0 && (
//                         <div className="action-checklist">
//                           <h5>Your Action Items:</h5>

//                           {tasks.map((item, i) => (
//                             <div key={i} className={`task-card ${item.done ? 'completed' : ''}`}>
//                               <div className="task-left">
//                                 <div className="task-title">{item.task}</div>
//                                 <div className="task-meta">📅 {item.dueDate}</div>
//                               </div>

//                               <input
//                                 type="checkbox"
//                                 className="task-checkbox"
//                                 checked={Boolean(item.done)}
//                                 disabled={item.done}
//                                 onChange={() => {
//                                   if (!item.done) {
//                                     handleToggleTask(meet.id, i);
//                                   }
//                                 }}
//                               />
//                             </div>
//                           ))}

//                         </div>
//                       )}
//                     </>
//                   )}

//                 </div>
//               </div>
//             );

//           }) : (
//             <p className="no-records">No 1-on-1 records found.</p>
//           )}
//         </div>
//       )}
//     </div>
//   );
// };

// export default OneOnOne;

































import React, { useState, useEffect } from 'react';
import '../styles/OneOnOne.css';

const OneOnOne = ({ userData, role }) => {
  const isLeader = role === 'Management' || role === 'Manager';

  // --- UI & LOADING STATE ---
  // const [activeTab, setActiveTab] = useState('create');
  const [searchTerm, setSearchTerm] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [toast, setToast] = useState(null);

  // --- MANAGER STATE ---
  const [employeeList, setEmployeeList] = useState([]);
  const [selectedEmp, setSelectedEmp] = useState(null);
  const [date, setDate] = useState('');
  const [discussion, setDiscussion] = useState('');
  const [shareWithEmployee, setShareWithEmployee] = useState(false);
  const [actions, setActions] = useState([{ task: '', dueDate: '', done: false }]);
  const [managerHistory, setManagerHistory] = useState([]);

  // --- EMPLOYEE STATE ---
  const [myMeetings, setMyMeetings] = useState([]);

  // --- INITIAL DATA LOAD ---
  useEffect(() => {
    if (isLeader) {
      fetch("/gt-api/get_employees.php", {
        credentials: "include"
      })
        .then(res => res.json())
        .then(data => setEmployeeList(data.employees || []));

      fetch(`/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`, {
        credentials: "include"
      })
        .then(res => res.json())
        .then(data => setManagerHistory(data.meetings || []));
    } else {
      fetch(`/gt-api/get_my_meetings.php?emp_id=${userData.id}`, {
        credentials: "include"
      })
        .then(res => res.json())
        // .then(data => setMyMeetings(data.meetings || []));
        .then(data => {
          console.log("EMP DATA:", data.meetings);  // 👈 ADD HERE
          setMyMeetings(data.meetings || []);
        });

    }
  }, [isLeader, userData.id]);

  const addActionRow = () => setActions([...actions, { task: '', dueDate: '', done: false }]);

  // --- ACTION: SAVE COMPLETED MEETING (MANAGER) ---
  const handleFinalSave = async () => {
    if (!selectedEmp || !date) {
      setToast({ message: "Please select both a date and an employee.", type: "error" });
      setTimeout(() => setToast(null), 4000);
      return;
    }
    setIsProcessing(true);
    const payload = {
      manager_id: userData.id,
      employee_id: selectedEmp.id,
      date: date,
      discussion: discussion,
      actions: JSON.stringify(actions),
      show_summary: shareWithEmployee ? 1 : 0
    };

    try {
      const response = await fetch('/gt-api/save_one_on_one.php', {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const rawText = await response.text();
      let result = { success: false };
      try {
        result = JSON.parse(rawText);
      } catch (e) {
        if (response.ok) {
          result = { success: true };
        } else {
          console.error("JSON parse error:", e, rawText);
        }
      }

      if (result.success) {
        setToast({ message: "Report submitted successfully!", type: "success" });
        setTimeout(() => {
          setToast(null);
          window.location.reload();
        }, 2000);
      } else {
        setToast({ message: "FAILED: " + (result.message || "Could not submit report."), type: "error" });
        setTimeout(() => setToast(null), 4000);
      }
    } catch (error) {
      console.error("Save Error:", error);
      setToast({ message: "ERROR: Failed to connect to server. Report not submitted.", type: "error" });
      setTimeout(() => setToast(null), 4000);
    } finally {
      setIsProcessing(false);
    }
  };

  // --- ACTION: REPORT MISSED MEETING ---
  const handleMissedMeeting = async () => {
    if (!selectedEmp || !date) {
      alert("Select employee and date to report a missed meeting.");
      return;
    }
    const confirmMissed = window.confirm(`PROTOCOL ALERT: Report ${selectedEmp.FirstName} as ABSENT?`);
    if (!confirmMissed) return;

    setIsProcessing(true);
    const payload = {
      manager_id: userData.id,
      manager_name: `${userData.FirstName} ${userData.LastName}`,
      employee_id: selectedEmp.id,
      employee_name: `${selectedEmp.FirstName} ${selectedEmp.LastName}`,
      date: date
    };

    try {
      const response = await fetch('/gt-api/report_missed_meeting.php', {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const result = await response.json();
      if (result.success) {
        alert("ALERT SENT: HR and Employee have been notified.");
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsProcessing(false);
    }
  };

  // --- ACTION: EMPLOYEE TASK TOGGLE (THE SYNC FIX) ---
  // --- ACTION: EMPLOYEE TASK TOGGLE ---
  const handleToggleTask = async (meetingId, taskIndex) => {
    // If meetingId is undefined or 0, the update will fail
    if (!meetingId) {
      alert("Error: This meeting hasn't been saved to the database yet.");
      return;
    }

    let updatedItemsString = "";

    const updatedMeetings = myMeetings.map(meet => {
      if (meet.id === meetingId) {
        let tasks = JSON.parse(meet.action_items || "[]");

        // ✅ prevent unchecking once done
        if (!tasks[taskIndex].done) {
          tasks[taskIndex].done = true;
        }

        updatedItemsString = JSON.stringify(tasks);
        return { ...meet, action_items: updatedItemsString };
      }
      return meet;
    });

    setMyMeetings(updatedMeetings);

    try {
      const response = await fetch('/gt-api/update_1to1_tasks.php', {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: meetingId,
          action_items: updatedItemsString
        })
      });

      const result = await response.json();

      if (result.success) {
        // 🔥 NEW: refresh manager-side data (no reload needed)
        if (isLeader && selectedEmp) {
          fetch(
            `/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`,
            {
              credentials: "include"
            }
          )
            .then(res => res.json())
            .then(data => {
              const filtered = (data.meetings || []).filter(
                m => m.employee_name === `${selectedEmp.FirstName} ${selectedEmp.LastName}`
              );
              setEmployeeHistory(filtered);
            });
        }
      } else {
        console.error("Database Update Failed:", result.message);
      }

    } catch (error) {
      console.error("Network Error:", error);
      alert("Connection failed. Ensure the record exists in the database.");
    }
  };


  const filteredHistory = [...managerHistory]
    .filter(meet => meet.employee_name?.toLowerCase().includes(searchTerm.toLowerCase()))
    .sort((a, b) => b.id - a.id);


  const uniqueEmployees = [...new Set(filteredHistory.map(m => m.employee_name))];


  const groupedByEmployee = filteredHistory.reduce((acc, meet) => {
    const name = meet.employee_name || "Unknown";

    if (!acc[name]) {
      acc[name] = [];
    }

    acc[name].push(meet);
    return acc;
  }, {});

  const [selectedEmployeeHistory, setSelectedEmployeeHistory] = useState(null);
  const [openMeetingId, setOpenMeetingId] = useState(null);

  const [editingMeetingId, setEditingMeetingId] = useState(null);
  const [editDiscussion, setEditDiscussion] = useState('');
  const [editTasks, setEditTasks] = useState([]);
  const [editShare, setEditShare] = useState(false);
  const handleUpdateMeeting = async (id) => {
    try {
      const response = await fetch('/gt-api/update_one_on_one_meeting.php', {
        method: 'POST',
        credentials: "include",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id,
          discussion: editDiscussion,
          actions: JSON.stringify(editTasks),
          show_summary: editShare ? 1 : 0
        })
      });

      const result = await response.json();

      if (result.success) {
        alert("Updated successfully");

        setEditingMeetingId(null);

        // 🔥 refresh UI
        setEmployeeHistory(prev =>
          prev.map(m =>
            m.id === id
              ? { ...m, discussion: editDiscussion, action_items: JSON.stringify(editTasks), show_summary: editShare ? 1 : 0 }
              : m
          )
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const [empSearch, setEmpSearch] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [employeeHistory, setEmployeeHistory] = useState([]);

  useEffect(() => {
    if (!selectedEmp) return;

    fetch(
      `/gt-api/get_oneonone.php?manager_id=${userData.id}&role=manager`,
      {
        credentials: "include"
      }
    )
      .then(res => res.json())
      .then(data => {

        const allMeetings = data.meetings || [];

        // ✅ CORRECT PLACE
        console.log("ONE MEETING:", allMeetings[0]);

        const filtered = allMeetings.filter(
          m => m.employee_name === `${selectedEmp.FirstName} ${selectedEmp.LastName}`
        );

        console.log("FILTERED:", filtered);

        setEmployeeHistory(filtered);
      });

  }, [selectedEmp]);


  return (
    <div className="one-on-one-container module-glass-card animate-fade">
      <style>{`
        @keyframes toastSlideDown {
          from { transform: translate(-50%, -20px); opacity: 0; }
          to { transform: translate(-50%, 0); opacity: 1; }
        }
      `}</style>

      {toast && (
        <div style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: toast.type === 'success' ? '#10b981' : '#ef4444',
          color: '#fff',
          padding: '14px 28px',
          borderRadius: '8px',
          boxShadow: toast.type === 'success'
            ? '0 10px 30px rgba(16, 185, 129, 0.3), 0 0 1px 1px rgba(255, 255, 255, 0.2)'
            : '0 10px 30px rgba(239, 68, 68, 0.3), 0 0 1px 1px rgba(255, 255, 255, 0.2)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          zIndex: 99999,
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: '14px',
          fontWeight: '600',
          letterSpacing: '0.5px',
          animation: 'toastSlideDown 0.3s ease-out forwards'
        }}>
          <span style={{ fontSize: '18px' }}>{toast.type === 'success' ? '✅' : '❌'}</span>
          <span>{toast.message}</span>
        </div>
      )}

      {isLeader ? (
        /* --- MANAGEMENT / LEADER VIEW --- */
        <div className="leader-view">

          <hr className="cyber-divider" />

          {/* ✅ KEEP YOUR ORIGINAL CREATE UI */}
          <div className="create-section">
            <div className="meet-grid">
              {/* <div className="input-field">
                <label>Select Date</label>
                <input type="date" value={date} onChange={(e) => setDate(e.target.value)} className="cyber-input" />
              </div> */}

              <div className="input-field date-field">
                <label>Select Date</label>
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  className="cyber-input"
                />
                <span className="calendar-icons">📅</span>
              </div>


              <div className="input-field">
                <label>Employee Name</label>
                <div className="employee-search-wrapper">
                  <input
                    type="text"
                    placeholder="Search Employee..."
                    className="cyber-input"
                    value={empSearch}
                    onChange={(e) => {
                      setEmpSearch(e.target.value);
                      setShowDropdown(true);
                    }}
                    onFocus={() => setShowDropdown(true)}
                  />

                  {showDropdown && (
                    <div className="employee-dropdown">
                      {employeeList
                        .filter(emp =>
                          `${emp.FirstName} ${emp.LastName}`
                            .toLowerCase()
                            .includes(empSearch.toLowerCase())
                        )
                        .map(emp => (
                          <div
                            key={emp.id}
                            className="dropdown-item"
                            onClick={() => {
                              setSelectedEmp(emp);
                              setEmpSearch(`${emp.FirstName} ${emp.LastName}`);
                              setShowDropdown(false);
                            }}
                          >
                            {emp.FirstName} {emp.LastName}
                          </div>
                        ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="input-field">
                <label>Department</label>
                <input type="text" readOnly value={selectedEmp?.Department || ''} className="cyber-input readonly" />
              </div>
            </div>

            <div className="discussion-area">
              <div className="discussion-header-row">
                <label>Discussion Summary</label>
                <div className="share-toggle-container">
                  <input type="checkbox" id="share-check" checked={shareWithEmployee} onChange={(e) => setShareWithEmployee(e.target.checked)} />
                  <label htmlFor="share-check" className="share-label">Share with Employee?</label>
                </div>
              </div>
              <textarea value={discussion} onChange={(e) => setDiscussion(e.target.value)} className="cyber-textarea" placeholder="Summarize key points..." />
            </div>

            <div className="actions-section">
              <h4>ACTION REQUIRED</h4>

              <div className="action-row-headers" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <label className="header-date" style={{ marginRight: '65px' }}>Due Date</label>
              </div>

              {actions.map((item, index) => (
                <div key={index} className="action-row-enhanced">
                  <input
                    type="text"
                    placeholder="Task description"
                    className="task-input"
                    onChange={(e) => {
                      const newActions = [...actions];
                      newActions[index].task = e.target.value;
                      setActions(newActions);
                    }}
                  />
                  <input
                    type="date"
                    className="date-picker-mini"
                    onChange={(e) => {
                      const newActions = [...actions];
                      newActions[index].dueDate = e.target.value;
                      setActions(newActions);
                    }}
                  />
                </div>
              ))}

              <button onClick={addActionRow} className="btn-add-row">+ Add Item</button>
            </div>

            <div className="button-group-main">
              <button onClick={handleFinalSave} className="btn-save-meet" disabled={isProcessing}>
                {isProcessing ? "SAVING..." : "SUBMIT REPORT"}
              </button>
              <button onClick={handleMissedMeeting} className="btn-missed-meet" disabled={isProcessing}>
                MARK AS MISSED
              </button>
            </div>
          </div>

          {/* ✅ ADD THIS NEW HISTORY SECTION */}
          <div className="employee-history-inline">

            {!selectedEmp ? (
              <div className="empty-history-dark">
                <div className="empty-icon">📊</div>
                <h4>No Employee Selected</h4>
                <p>Select an employee to view their meeting history</p>
              </div>
            ) : (
              <>
                <h3 style={{ marginTop: "20px" }}>
                  {selectedEmp.FirstName}'s Previous Meetings
                </h3>

                {employeeHistory.length === 0 && (
                  <p style={{ opacity: 0.6 }}>No history found</p>
                )}

                {
                  employeeHistory.map(meet => {
                    // const isMissed = meet.status === "MISSED";
                    const isMissed =
                      meet.status === "MISSED" ||
                      meet.discussion?.includes("MISSED_MEETING_REPORT");
                    const tasks = JSON.parse(meet.action_items || "[]")
                      .filter(t => t.task && t.task.trim() !== "");

                    return (
                      <div key={meet.id} className={`history-card ${isMissed ? 'missed' : ''}`}>

                        {/* HEADER */}
                        <div className="history-header">
                          <div className="history-date">
                            📅 {meet.meet_date}
                          </div>

                          {/* EDIT BUTTON */}
                          {!isMissed && (
                            <button
                              className="edit-btn"
                              onClick={() => {
                                setEditingMeetingId(meet.id);
                                setEditDiscussion(meet.discussion);
                                setEditTasks(tasks);
                                setEditShare(Number(meet.show_summary) === 1);
                              }}
                            >
                              ✏️ Edit
                            </button>
                          )}
                        </div>

                        {/* MISSED */}
                        {isMissed ? (
                          <div className="missed-box">
                            ❌ Missed Meeting
                          </div>
                        ) : (
                          <>
                            {/* DISCUSSION */}
                            <div className="history-discussion">
                              {meet.discussion?.split('\n').map((line, i) => (
                                <p key={i}>{line}</p>
                              ))}
                            </div>

                            {/* ACTION ITEMS */}
                            {tasks.length > 0 && (
                              <div className="history-tasks">
                                <h5>Action Items</h5>

                                {tasks.map((task, i) => (
                                  <div key={i} className={`task-item ${task.done ? 'completed' : ''}`}>

                                    <div className="task-text">
                                      {task.done ? "✅ " : ""}{task.task}
                                    </div>

                                    <div className="task-date">📅 {task.dueDate}</div>

                                  </div>
                                ))}
                              </div>
                            )}
                          </>
                        )}

                        {/* EDIT MODE */}
                        {editingMeetingId === meet.id && (
                          <div className="edit-container">

                            <h4 className="edit-title">✏️ Edit Meeting</h4>

                            {/* DISCUSSION */}
                            <div className="edit-group">
                              <label>Discussion</label>
                              <textarea
                                className="edit-textarea"
                                value={editDiscussion}
                                onChange={(e) => setEditDiscussion(e.target.value)}
                              />
                            </div>

                            {/* SHARE WITH EMPLOYEE TOGGLE */}
                            <div className="edit-group" style={{ marginTop: '10px', marginBottom: '10px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                <input
                                  type="checkbox"
                                  id={`edit-share-${meet.id}`}
                                  checked={editShare}
                                  onChange={(e) => setEditShare(e.target.checked)}
                                  style={{ cursor: 'pointer' }}
                                />
                                <label htmlFor={`edit-share-${meet.id}`} style={{ cursor: 'pointer', fontSize: '12px', userSelect: 'none', color: 'rgba(255, 255, 255, 0.7)' }}>
                                  Share summary and action items with Employee?
                                </label>
                              </div>
                            </div>

                            {/* TASKS */}
                            <div className="edit-group">
                              <label>Action Items</label>

                              {editTasks.map((t, i) => (
                                <div key={i} className="edit-task-row">
                                  <input
                                    className="edit-task-input"
                                    value={t.task}
                                    placeholder="Task..."
                                    onChange={(e) => {
                                      const updated = [...editTasks];
                                      updated[i].task = e.target.value;
                                      setEditTasks(updated);
                                    }}
                                  />

                                  <input
                                    type="date"
                                    className="edit-date-input"
                                    value={t.dueDate}
                                    onChange={(e) => {
                                      const updated = [...editTasks];
                                      updated[i].dueDate = e.target.value;
                                      setEditTasks(updated);
                                    }}
                                  />
                                </div>
                              ))}

                              <button
                                className="add-task-btn"
                                onClick={() =>
                                  setEditTasks([...editTasks, { task: "", dueDate: "" }])
                                }
                              >
                                + Add Task
                              </button>
                            </div>

                            {/* ACTION BUTTONS */}
                            <div className="edit-actions">
                              <button
                                className="cancel-btn"
                                onClick={() => setEditingMeetingId(null)}
                              >
                                Cancel
                              </button>

                              <button
                                className="save-btn"
                                onClick={() => handleUpdateMeeting(meet.id)}
                              >
                                Save Changes
                              </button>
                            </div>

                          </div>
                        )}

                      </div>
                    );
                  })
                }


              </>
            )}

          </div>

        </div>
      ) : (
        /* --- EMPLOYEE VIEW --- */
        <div className="employee-view">
          {/* <h3 className="dashboard-headline">🚀 ACTION REQUIRED TO EMPLOYEE DASHBOARD</h3> */}

          {myMeetings.length > 0 ? myMeetings.map(meet => {

            const tasks = JSON.parse(meet.action_items || "[]")
              .filter(t => t.task && t.task.trim() !== "");

            return (
              <div key={meet.id} className="meet-log-card">

                <div className="meet-header">
                  <span>📅 {meet.meet_date}</span>
                  <span>👤 Manager: {meet.manager_name}</span>
                </div>

                <div className="employee-content-box">

                  {/* ✅ DETECT MISSED */}
                  {(
                    meet.status === "MISSED" ||
                    meet.discussion?.includes("MISSED_MEETING_REPORT")
                  ) ? (
                    <div className="missed-box">
                      ❌ You missed this meeting
                    </div>
                  ) : (
                    <>
                      {Number(meet.show_summary) === 1 ? (
                        <div className="emp-disc">
                          {meet.discussion?.split('\n').map((line, idx) => (
                            <div key={idx} className="discussion-line">
                              {line}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <p className="restricted">One on one completed</p>
                      )}

                      {/* ✅ SHOW ONLY IF TASKS EXIST */}
                      {tasks.length > 0 && (
                        <div className="action-checklist">
                          <h5>Your Action Items:</h5>

                          {tasks.map((item, i) => (
                            <div key={i} className={`task-card ${item.done ? 'completed' : ''}`}>
                              <div className="task-left">
                                <div className="task-title">{item.task}</div>
                                <div className="task-meta">📅 {item.dueDate}</div>
                              </div>

                              <input
                                type="checkbox"
                                className="task-checkbox"
                                checked={Boolean(item.done)}
                                disabled={item.done}
                                onChange={() => {
                                  if (!item.done) {
                                    handleToggleTask(meet.id, i);
                                  }
                                }}
                              />
                            </div>
                          ))}

                        </div>
                      )}
                    </>
                  )}

                </div>
              </div>
            );

          }) : (
            <p className="no-records">No 1-on-1 records found.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default OneOnOne;


























